<template>
  <b-col md="9" class="mh-100">
    <b-overlay :blur="null" :show="loading" class="h-100" opacity="0">
      <transition mode="out-in" name="fadeDownShort">
        <div v-if="!loading" class="d-flex flex-column h-100">
          <b-card
            body-class="py-0"
            class="border-0 mb-3"
            header-class="pb-2 border-0 bg-transparent"
          >
            <template #header>
              <div class="d-flex justify-content-between">
                <div class="title">
                  <h3 class="d-inline-block font-weight-bolder mb-0 mr-2">
                    {{ current.data.name }}
                  </h3>
                  <b-badge v-if="current.data.group" tag="sup">
                    {{ current.data.group.name }}
                  </b-badge>
                  <b-badge
                    v-if="!current.data.active"
                    variant="danger"
                    tag="sup"
                  >
                    NEAKTÍVNY
                  </b-badge>
                </div>
                <h4 class="font-weight-normal text-muted mb-0">
                  {{ current.data.street }} {{ current.data.streetNumber }},
                  {{ current.data.city }}
                </h4>
              </div>
            </template>
            <b-nav class="nav-base">
              <b-nav-item :to="{ name: 'customerGeneral' }">
                <b-icon class="mr-1" icon="card-text" />
                Všeobecné
              </b-nav-item>
              <b-nav-item
                :to="{
                  name: 'customerEnergetics',
                  params: { energetics_id: energetics },
                }"
              >
                <b-icon class="mr-1" icon="grid" />
                Odberné miesta
                <transition-group class="ml-1" name="fadeRightShort">
                  <b-badge
                    v-if="badges.energetics.power"
                    key="power"
                    class="bg-power mr-1"
                  >
                    <icon class="icon-fw" name="plug" scale="0.75" />
                    {{ badges.energetics.power }}
                  </b-badge>
                  <b-badge
                    v-if="badges.energetics.gas"
                    key="gas"
                    class="bg-gas mr-1"
                  >
                    <icon class="icon-fw" name="fire" scale="0.75" />
                    {{ badges.energetics.gas }}
                  </b-badge>
                  <b-badge
                    v-if="badges.energetics.water"
                    key="water"
                    class="bg-water mr-1"
                  >
                    <icon class="icon-fw" name="tint" scale="0.75" />
                    {{ badges.energetics.water }}
                  </b-badge>
                  <b-badge
                    v-if="badges.energetics.heat"
                    key="heat"
                    class="bg-heat"
                  >
                    <icon class="icon-fw" name="sun" scale="0.75" />
                    {{ badges.energetics.heat }}
                  </b-badge>
                </transition-group>
              </b-nav-item>
              <b-nav-item :to="{ name: 'customerDocuments' }">
                <b-icon class="mr-1" icon="folder2-open" />
                Dokumenty
                <b-badge pill variant="primary">
                  {{ badges.documents }}
                </b-badge>
              </b-nav-item>
              <b-nav-item :to="{ name: 'customerHistory' }">
                <b-icon class="mr-1" icon="clock-history" />
                História
                <b-badge pill variant="primary">
                  {{ badges.history }}
                </b-badge>
              </b-nav-item>
            </b-nav>
          </b-card>
          <transition mode="out-in" name="fadeRightShort">
            <router-view />
          </transition>
        </div>
      </transition>
    </b-overlay>
  </b-col>
</template>
<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      loading: false,
      badges: {},
    }
  },
  computed: {
    ...mapState({
      current: (state) => state.customer.current,
    }),
    energetics() {
      if (!this.$route.params.energetics_id) {
        return this.current.meta.energetics.length
          ? this.current.meta.energetics[0]
          : 0
      }
      return this.$route.params.energetics_id
    },
  },
  created() {
    this.fetchData()
  },
  mounted() {
    this.$root.$on('reloadCustomerData', this.fetchData)
  },
  beforeDestroy() {
    this.$root.$off('reloadCustomerData')
  },
  methods: {
    fetchData() {
      this.loading = true
      this.$store
        .dispatch('customer/getCurrent', this.$route.params.id)
        .then(() => {
          this.$api
            .get(`customers/${this.$route.params.id}/get_badges`)
            .then((res) => {
              this.badges = res.data.data
              this.loading = false
            })
        })
    },
  },
}
</script>
